import { Component } from '@angular/core';

@Component({
  selector: 'register-page',
  templateUrl: './register.component.html'
})
export class RegisterComponent{}


// WEBPACK FOOTER //
// C:/Users/leoth/Desktop/Leo/Programming/Hackathons/Octocite/octocite/src/app/register.component.ts